export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'name', label: 'name', sortable: true },
    { key: 'science_sector_code', label: 'Science sector code', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
  }
}
